module.exports = __webpack_public_path__ + "978202ff3ad9a5d8233d7b05ac2afd09.svg";